import { TogglesState } from '.';
import AppConstants from '../../components/App/constants';

const reducers = {
  setHideFunding: (
    toggles,
    payload: { hidePlaid: boolean; hideManualACH: boolean; hideDebit: boolean }
  ) => ({
    ...toggles,
    hideFunding: {
      hidePlaid: payload.hidePlaid,
      hideManualACH: payload.hideManualACH,
      hideDebit: payload.hideDebit
    }
  }),

  setPlaidLinkEnabled: (toggles, payload: { enabled: boolean }) => ({
    ...toggles,
    plaidLinkEnabled: payload.enabled
  }),

  setAddChildCOPPA: (
    toggles,
    payload: {
      enabled: boolean;
      requireChildDateOfBirth: boolean;
      displayDisclaimer: boolean;
    }
  ) => ({
    ...toggles,
    addChildCOPPA: {
      enabled: payload.enabled,
      requireChildDateOfBirth: payload.requireChildDateOfBirth,
      displayDisclaimer: payload.displayDisclaimer
    }
  }),

  setProveComplianceEnabled: toggles => ({
    ...toggles,
    proveComplianceEnabled: true
  }),

  setBaseDomain: (toggles, payload: { baseDomain: string }) => ({
    ...toggles,
    baseDomain: payload.baseDomain || AppConstants.BASE_DOMAIN.defaultBaseDomain
  }),

  setAccessManagementEnabled: (
    toggles,
    payload: { accessManagementEnabled: boolean }
  ) => ({
    ...toggles,
    accessManagementEnabled: payload.accessManagementEnabled
  }),

  setPromoCodeVerificationEnabled: (
    toggles,
    payload: { enabled: boolean }
  ) => ({
    ...toggles,
    promoCodeVerificationEnabled: payload.enabled
  }),

  setIsFbPixelEnabled: (toggles, payload: { enabled: boolean }) => ({
    ...toggles,
    isFbPixelEnabled: payload.enabled
  }),

  setAutofundingPreferred: (
    toggles,
    payload: { autofundingPreferred: boolean }
  ) => ({
    ...toggles,
    autofundingPreferred: payload.autofundingPreferred
  }),

  setMinimumWalletLoad: (
    toggles,
    payload: {
      shouldShift: boolean;
      minimumLoadAmount: number;
      displayMinimumAmount: number;
    }
  ) => ({
    ...toggles,
    walletMinimum: {
      shouldShift: payload.shouldShift || false,
      amount: payload.minimumLoadAmount || 20,
      displayAmount: payload.displayMinimumAmount
    }
  }),

  setPlaidOAuthManualOverride: (toggles, payload: { enabled: boolean }) => ({
    ...toggles,
    plaidOAuthManualOverrideEnabled: payload.enabled
  }),

  setPlaidOAuthAndroidLink: (toggles, payload: { enabled: boolean }) => ({
    ...toggles,
    plaidOAuthAndroidLinkEnabled: payload.enabled
  }),

  setUnauthorizedCleanStateEnabled: toggles => ({
    ...toggles,
    unauthorizedCleanStateEnabled: true
  }),

  setEmailBlurEnabled: toggles => ({
    ...toggles,
    emailBlurEnabled: true
  }),

  setSmsNotificationsEnabled: (
    toggles,
    payload: { defaultChecked: boolean }
  ) => ({
    ...toggles,
    smsNotificationsEnabled: true,
    smsNotificationsDefaultChecked: payload.defaultChecked
  }),

  setEnhancedDebitOptions: (
    toggles,
    payload: {
      applePayEnabled: boolean;
      googlePayEnabled: boolean;
      threeDSEnabled: boolean;
      paypalEnabled: boolean;
      venmoEnabled: boolean;
    }
  ) => ({
    ...toggles,
    enhancedDebit: {
      enhancedDebitEnabled: true,
      applePayEnabled: payload.applePayEnabled,
      googlePayEnabled: payload.googlePayEnabled,
      threeDSEnabled: payload.threeDSEnabled,
      paypalEnabled: payload.paypalEnabled,
      venmoEnabled: payload.venmoEnabled
    }
  }),
  setFeatureToggles: (toggles, payload: Record<string, unknown>) => ({
    ...toggles,
    featureToggles: payload
  }),

  setPreferNotToSayOptionEnabled: toggles => ({
    ...toggles,
    preferNotToSayOptionEnabled: true
  }),

  setProveMobileAuthEnabled: (
    toggles,
    payload: { noPhoneNumberPriceText: boolean }
  ) => ({
    ...toggles,
    proveMobileAuthEnabled: true,
    noPhoneNumberPriceText: payload.noPhoneNumberPriceText
  }),

  setNativePlaidFlowEnabled: toggles => ({
    ...toggles,
    nativePlaidFlowEnabled: true
  }),

  setCreditWaitlistEnabled: (
    toggles,
    payload: {
      creditWaitlistEnabled: boolean;
      creditWaitlistShowConfirmScreen: boolean;
    }
  ) => ({
    ...toggles,
    creditWaitlistEnabled: payload.creditWaitlistEnabled,
    creditWaitlistShowConfirmScreen: payload.creditWaitlistShowConfirmScreen
  }),

  setNewCardImageEnabled: toggles => ({
    ...toggles,
    setNewCardImageEnabled: true
  }),

  setRequireTokenForApproversEnabled: toggles => ({
    ...toggles,
    requireTokenForApproversEnabled: true
  }),

  setPersonasServiceEnabled: toggles => ({
    ...toggles,
    personasServiceEnabled: true
  }),

  setInitialToggleState: (toggles, initialToggles: Partial<TogglesState>) => ({
    ...toggles,
    ...initialToggles
  })
};

export default { ...reducers };
